<template>
  <div>
    <o-table ref="tableList"
             :enable-edit="false"
             :enable-new="hasPermission(['POST api/sandoz/gadget/contracts/{id}'])"
             :title="$t('sandoz.gadget_contracts')"
             default-sort-by="id"
             default-sort-by-direction="desc"
             url="/api/sandoz/gadget/contracts"
    >
      <template slot="filter">
        <o-filter :filter-cacheable="true" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
          <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
          <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
          <o-filter-text :title="$t('sandoz.responsible_sales_person')"
                         column="responsible_sales_person"></o-filter-text>
          <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
          <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
          <o-filter-checkbox :items="previousContract" :title="$t('sandoz.has_previous_contract')"
                             column="no_previous_contract"></o-filter-checkbox>
          <o-filter-select :items="types" :title="$t('sandoz.contract_type')" column="type"></o-filter-select>
          <o-filter-text :title="$t('sandoz.company_name')" column="company_name"></o-filter-text>
          <o-filter-text :title="$t('sandoz.name')" column="name"></o-filter-text>
          <o-filter-text :placeholder="$t('sandoz.street_zip_city')" :title="$t('sandoz.address')"
                         column="address"></o-filter-text>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
        <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
        <o-table-header :sortable="false">{{ $t('sandoz.company_name') }}</o-table-header>
        <o-table-header column="responsible_sales_person">{{ $t('sandoz.responsible_sales_person') }}</o-table-header>
        <o-table-header column="status">{{ $t('sandoz.status') }}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
        <td>{{ props.item.contract_no }}</td>
        <td>{{ props.item.customer_external_id }}</td>
        <td>{{ props.item.company_name }}</td>
        <td>{{ props.item.responsible_sales_person }}</td>
        <td>
          <span v-if="props.item.status == 'Feedback' || props.item.status == 'Rejected'" class="text-danger">
            {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
            <fa icon="info-circle" @click.prevent="showFeedback(props.item)"></fa>
          </span>
          <span v-else>
            {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
          </span>
        </td>
      </template>
      <template slot="body-controls" slot-scope="props">
        <td class="text-right">
          <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
            <o-delete :url="'/api/sandoz/gadget/contracts/' + props.item.id" method="delete"
                      v-on:action-executed="$refs.tableList.search"></o-delete>
            <router-link v-if="(props.item.status === 'Draft' || props.item.status === 'Feedback') && hasPermission(['POST api/sandoz/gadget/contracts/{id}'])" :to="{ path: $route.path + '/' + props.item.id }"
                         class="btn btn-primary">
              <fa icon="pencil-alt"/>
            </router-link>
            <router-link v-else :to="{ path: $route.path + '/view/' + props.item.id }" class="btn btn-primary">
              <fa icon="eye"/>
            </router-link>
          </div>
        </td>
      </template>
    </o-table>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import {contractYears} from '../../../utils/contractYear'

export default {
  data: () => ({
    status: [],
    years: [],
    types: [],
    previousContract: [],
    contract: null
  }),
  created() {
    this.years = contractYears()

    this.status = [
      {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
      {value: 'Draft', text: this.$i18n.t('sandoz.draft')},
      {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
      {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
      {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
      {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
      {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')},
      {value: 'Feedback', text: this.$i18n.t('sandoz.feedback')},
      {value: 'Rejected', text: this.$i18n.t('sandoz.rejected')},
      {value: 'Approved', text: this.$i18n.t('sandoz.approved')}
    ]
    this.previousContract = [
      {value: 'Yes', text: this.$i18n.t('sandoz.yes')},
      {value: 'No', text: this.$i18n.t('sandoz.no')}
    ]

    this.types = [
      {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
      {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
      /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
      {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
      {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
      {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
      {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
      {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
    ]
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    hasPermission(item) {
      let result = true
      let permissions = item
      let user = this.user
      if (!user.is_super_user && permissions) {
        permissions.forEach((permission) => {
          if (!user.routePermissions.includes(permission)) {
            result = false
          }
        })
      }
      return result
    },
    showFeedback(item) {
      window.alert(item.approval_feedback)
    },
  }
}
</script>
